import useJourneyContext from "./useJourneyContext";
const useJourneyPlan = () => {
  return useJourneyContext().journey;
};
var useJourneyPlan_default = useJourneyPlan;
export {
  useJourneyPlan_default as default
};
